"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../../api/webAApi");
var EventBindingOnCashBackCfgCtl = /** @class */ (function (_super) {
    __extends(EventBindingOnCashBackCfgCtl, _super);
    function EventBindingOnCashBackCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingOnCashBackCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            is_only_create_on_exact_day_of_month_number: false,
            only_create_on_exact_day_of_month_number: 0,
            is_only_create_on_exact_day_of_week_number: false,
            only_create_on_exact_day_of_week_number: 0,
            is_only_create_on_exact_hour_of_day_number: false,
            create_on_exact_hour_of_day_number: 0,
            check_cashback_timeout_minutes: 0
        };
    };
    EventBindingOnCashBackCfgCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.DetailsBrandBonusEventBindingConfigOnCashBackGet.exec({ event_binding_id: key }, function (resp) {
            _this.DATA.is_only_create_on_exact_day_of_month_number = resp.is_only_create_on_exact_day_of_month_number;
            _this.DATA.only_create_on_exact_day_of_month_number = resp.only_create_on_exact_day_of_month_number;
            _this.DATA.is_only_create_on_exact_day_of_week_number = resp.is_only_create_on_exact_day_of_week_number;
            _this.DATA.only_create_on_exact_day_of_week_number = resp.only_create_on_exact_day_of_week_number;
            _this.DATA.is_only_create_on_exact_hour_of_day_number = resp.is_only_create_on_exact_hour_of_day_number;
            _this.DATA.create_on_exact_hour_of_day_number = resp.create_on_exact_hour_of_day_number;
            _this.DATA.check_cashback_timeout_minutes = resp.check_cashback_timeout_minutes;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingOnCashBackCfgCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoEditBrandBonusEventBindingConfigOnCachBack.exec({
            data: {
                event_binding_id: data.event_binding_id,
                is_only_create_on_exact_day_of_month_number: data.is_only_create_on_exact_day_of_month_number,
                only_create_on_exact_day_of_month_number: data.only_create_on_exact_day_of_month_number,
                is_only_create_on_exact_day_of_week_number: data.is_only_create_on_exact_day_of_week_number,
                only_create_on_exact_day_of_week_number: data.only_create_on_exact_day_of_week_number,
                is_only_create_on_exact_hour_of_day_number: data.is_only_create_on_exact_hour_of_day_number,
                create_on_exact_hour_of_day_number: data.create_on_exact_hour_of_day_number,
                check_cashback_timeout_minutes: data.check_cashback_timeout_minutes
            }
        }, function (resp) {
            _this.DATA.is_only_create_on_exact_day_of_month_number = data.is_only_create_on_exact_day_of_month_number;
            _this.DATA.only_create_on_exact_day_of_month_number = data.only_create_on_exact_day_of_month_number;
            _this.DATA.is_only_create_on_exact_day_of_week_number = data.is_only_create_on_exact_day_of_week_number;
            _this.DATA.only_create_on_exact_day_of_week_number = data.only_create_on_exact_day_of_week_number;
            _this.DATA.is_only_create_on_exact_hour_of_day_number = data.is_only_create_on_exact_hour_of_day_number;
            _this.DATA.create_on_exact_hour_of_day_number = data.create_on_exact_hour_of_day_number;
            _this.DATA.check_cashback_timeout_minutes = data.check_cashback_timeout_minutes;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return EventBindingOnCashBackCfgCtl;
}(BaseController_1.BaseController));
exports.EventBindingOnCashBackCfgCtl = EventBindingOnCashBackCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/event_config/config_on_cashback/EventBindingOnCashBackCfgCtl.ts
// module id = 981
// module chunks = 0